import styled from 'styled-components';
import { device, typography } from '@/styles/helpers';

export const ScComparisonSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;

  & .slider-wrapper {
    display: none;
    @media (${device.mobileS}) {
      display: block;
    }
  }

  & .table-wrapper {
    display: block;
    @media (${device.mobileS}) {
      display: none;
    }
  }
`;

export const ScButtonWrapper = styled.div`
  width: 100%;
  max-width: 280px;
  margin: 0 auto;
  @media (${device.mobileS}) {
    margin-top: 20px;
  }
`;

export const ScTitle = styled.h2`
  ${typography.headline2};
  text-align: left;
  text-transform: uppercase;
  color: ${({ theme }) => theme.whiteColor};
  @media (${device.mobile}) {
    text-align: center;
  }
`;
